import { AfterContentInit, Component, ElementRef, HostListener, Input, OnChanges, ViewChild } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnChanges, AfterContentInit {

  @ViewChild('tooltip', { static: true }) private tooltipRef: ElementRef;
  @ViewChild('tooltipContent', { static: true }) private tooltipContentRef: ElementRef;

  @Input() type = 'info';
  @Input() tooltipText: string;
  @Input() icon = 'info';

  @Input() directionH?: 'left' | 'right';
  @Input() directionV?: 'top' | 'bottom';
  @Input() iconWidth?: string;

  firstEventInTooltip: boolean = true;
  tooltipContainsLink: boolean = false;
  tooltipClasses: { [key: string]: boolean };

  readonly ESC_KEY_CODE = 27;
  readonly TAB_KEY_CODE = 9;

  ngOnChanges() {
    this.tooltipClasses = this.getTooltipClasses();
  }

  ngAfterContentInit(): void {
    this.tooltipContainsLink = this.isTooltipContainingLink();
  }

  private getTooltipClasses(): { [key: string]: boolean } {
    const directionV = this.directionV;
    const directionH = this.directionH;
    const classes = {
      'info': true
    };
    classes[directionH] = !!this.directionH;
    classes[directionV] = !!this.directionV;
    return classes;
  }

  @HostListener('mouseenter')
  setDirectionClass(): void {
    if (!this.directionH) {
      this.isTooltipExceedingWindow() ? this.setLeftDirection() : this.setRightDirection();
    }
  }

  @HostListener('keydown', ['$event'])
  tooltipKeyDownEvents(event: KeyboardEvent): void {
    if (event.keyCode === this.TAB_KEY_CODE) {
      // Nawigowanie focusem z użyciem klawisza Tab

      if (!event.shiftKey) {
        if (this.tooltipContainsLink) {
          if (this.firstEventInTooltip) {
            this.tooltipRef.nativeElement.classList.add('tooltipShouldBeOpened');
            this.firstEventInTooltip = false;
          } else {
            if (this.tooltipRef.nativeElement.classList.contains('tooltipShouldBeOpened')) {
              this.tooltipRef.nativeElement.classList.remove('tooltipShouldBeOpened');
            }
            this.firstEventInTooltip = true;
          }
        }
      } else {
        // Obsługa klawisza Tab + Shift
        // Ukrywanie tooltipa, gdy nawigujemy focusem wstecz
        if (this.tooltipRef.nativeElement.classList.contains('tooltipShouldBeOpened')) {
          this.tooltipRef.nativeElement.classList.remove('tooltipShouldBeOpened');
        }
        this.firstEventInTooltip = true;
      }
    } else if (event.keyCode === this.ESC_KEY_CODE) {
      // Ukrywanie tooltipa po wciśnięciu Esc
      this.tooltipRef.nativeElement.blur();
      if (this.tooltipContainsLink && !this.firstEventInTooltip &&
        this.tooltipRef.nativeElement.classList.contains('tooltipShouldBeOpened')) {
        this.tooltipRef.nativeElement.classList.remove('tooltipShouldBeOpened');
      }
      this.firstEventInTooltip = true;
    }
  }

  @HostListener('document:click', ['$event'])
  tooltipClickEvent(event: MouseEvent): void {
    const clickedInside = this.tooltipRef.nativeElement.contains(event.target as HTMLElement);
    if (!clickedInside && this.tooltipContainsLink) {
      if (this.tooltipRef.nativeElement.classList.contains('tooltipShouldBeOpened')) {
        this.tooltipRef.nativeElement.classList.remove('tooltipShouldBeOpened');
      }
      this.firstEventInTooltip = true;
    }
  }

  private isTooltipExceedingWindow(): boolean {
    const windowWidth = window.innerWidth;
    const tooltipBoundaryLeft = this.tooltipRef.nativeElement.getBoundingClientRect().right;
    return tooltipBoundaryLeft + 280 > windowWidth;
  }

  private setLeftDirection(): void {
    this.tooltipRef.nativeElement.classList.remove('right');
    this.tooltipRef.nativeElement.classList.add('left');
  }

  private setRightDirection(): void {
    this.tooltipRef.nativeElement.classList.remove('left');
    this.tooltipRef.nativeElement.classList.add('right');
  }

  private isTooltipContainingLink(): boolean {
    const tooltipContentNodeList: NodeList = this.tooltipContentRef.nativeElement.childNodes;
    let linkExists: boolean = false;
    tooltipContentNodeList.forEach((node: Node) => {
      if (node.nodeName === 'A') {
        linkExists = true;
      }
    });
    return linkExists;
  }
}
